import { render, staticRenderFns } from "./WhatsAppHistory.vue?vue&type=template&id=1d055903&scoped=true"
import script from "./WhatsAppHistory.vue?vue&type=script&lang=js"
export * from "./WhatsAppHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d055903",
  null
  
)

export default component.exports